import { JsonWriteOptions } from '@bufbuild/protobuf';

/**
 * Enums are serialised as their proto name, not as an integer.
 *
 * The generated `*Json` types declare enum fields as proto-name string unions,
 * so emitting integers made every one of those types untrue about its own
 * contents and hid mismatches from the compiler. Proto names also match what
 * the Go API, Postgres and Typesense store. `fromJson` still accepts integers,
 * so records written before this change stay readable.
 */
export const defaultApiSerializeJsonOptions: Partial<JsonWriteOptions> = {
  alwaysEmitImplicit: true,
};
